<template>
  <el-dialog
    :visible.sync="innerVisible"
    width="440px"
    custom-class="ca-info-dialog"
    :close-on-click-modal="true"
  >
    <div slot="title" class="ca-info-dialog__title">
      <i class="el-icon-success ca-info-dialog__icon" />
      <span>CA信息</span>
    </div>
    <div v-for="(label, key) in LABELS" :key="key" class="ca-info-dialog__row">
      <span class="ca-info-dialog__label">{{ label }}：</span>
      <span class="ca-info-dialog__value">{{ displayValue(key) }}</span>
    </div>
  </el-dialog>
</template>

<script>
// 行标签（key 顺序即渲染顺序，仅已寄出订单可查看）
const LABELS = {
  orderCode: '订单号',
  caSerialNo: 'CA序列号',
  postFirmName: '快递公司',
  postOrderId: '快递单号',
}

export default {
  name: 'CaInfoDialog',
  props: {
    visible: { type: Boolean, default: false },
    order: { type: Object, default: () => ({}) },
  },
  data() {
    return { LABELS }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(v) {
        this.$emit('update:visible', v)
      },
    },
  },
  methods: {
    displayValue(key) {
      const v = this.order[key]
      // 上海CA 序列号未回传时展示「待回传」
      if (key === 'caSerialNo' && !v) return '待回传'
      return v || '--'
    },
  },
}
</script>
